import { toast } from "react-toastify"
import { ErrorHandlerType } from "../types"

const useQuizApiErrorHandler = () => {
  const quizApiErrorHandler: ErrorHandlerType = {
    500: () => {
      toast.error(
        "서버 오류로 문항을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.",
        {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      )
    },
  }

  return { quizApiErrorHandler }
}

export default useQuizApiErrorHandler
